// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_64bd66bf"};